import { EnvironmentNames } from 'src/app/_core/contants/environments';
import { EFT_INSTRUCTIONS_GLF, WIRING_INSTRUCTIONS_GLF } from 'src/app/_core/contants/wiring-instructions';

export const environment = {
  // Assets
  primaryColor: 'rgba(66, 176, 255, 1)',
  secondaryColor: 'rgba(164, 217, 255, 1)',
  ternaryColor: '#42B0FF',
  logo: 'assets/logos/glf.png',
  publicLogo: 'assets/logos/glf2.png',
  lightDonateNowButtonLink:
    'https://tbportal-prod-assets.s3.us-east-1.amazonaws.com/igf/IGF%20Donate%20Button%20%28Light%29.png',
  darkDonateNowButtonLink:
    'https://tbportal-prod-assets.s3.us-east-1.amazonaws.com/igf/IGF%20Donate%20Button%20%28Dark%29.png',
  lightDonateNowButtonSrc: 'assets/donate-buttons/igf_light_donate_button.png',
  darkDonateNowButtonSrc: 'assets/donate-buttons/igf_dark_donate_button.png',
  favicon: 'assets/favicon/glf.ico',
  wiringInstructions: WIRING_INSTRUCTIONS_GLF,
  eftInstructions: EFT_INSTRUCTIONS_GLF,
  stripeKey:
    'pk_test_51U5kuEDiZzDoHoztgCwcSsf1qsOsom9MvaKk6M5wvMD1FKJNmHokNgMxZr4AEipFAKQAVkiTP9dlJnFCRaEOuyRH00V91YiCHP',
  homeLink: 'https://www.giverslegacy.com',
  contact: 'https://giverslegacy.com/contact',
  blog: '',
  privacyPolicy: 'https://www.giverslegacy.com/privacy',
  terms: 'https://www.giverslegacy.com/terms',
  mailTo: 'admin@giverslegacy.com',
  name: 'Givers Legacy Foundation',
  // Server
  tenantId: 'glf_test',
  server: 'https://fms-test.trustbridgeglobal.com/api',
  url: 'https://fms-test.trustbridgeglobal.com',
  gsUrl: 'https://test.givingspace.com',
  // Frontend Logic
  production: false,
  environmentName: EnvironmentNames.GLF,
  languages: ['en-glf'],
  multiCurrency: false,
  redirectSourceUrl: null,
  backendClientId: 'glf_test-portal-backend',
  authConfig: {
    issuer: 'https://test.sso.benevatech.com/auth/realms/BenevaTechTest',
    redirectUri: window.location.origin,
    clientId: 'glf_test-portal-public',
    responseType: 'code',
    scope: 'openid profile email links',
    showDebugInformation: true,
    sessionChecksEnabled: true,
  },
  signatureApiKey: '',
};
